// extracted by mini-css-extract-plugin
export default {"magnifier":"simpleMagnifierIcon_magnifier__tjiOy"};